export default {
    // $ 公共
    general_button_cancel: 'Cancelar',
    general_button_sure: 'Confirmar',
    general_button_close: 'Cerrar',
    general_text_update_faild: 'Actualización fallida',
    general_button_done: 'Hecho',
    general_text_no_data: 'Datos no encontrados',
    general_text_ordered: 'Pedido',
    general_text_next_turn_time: 'Turno',
    general_text_get_limit_rule_failed: 'No fue posible obtener las reglas del turno.',
    general_text_customer_not_exist: 'El usuario {{n}} no existe',
    general_text_can_not_get_rules_of_dish: 'No fue posible obtener los datos del plato',

    // $ 历史订单
    order_history_page_text_no_make: 'No hecho',
    order_history_page_text_make_complete: 'En entrega',
    order_history_page_text_service_complete: 'Servido',
    order_history_page_text_unable_make: 'Cancelado',
    order_history_page_text_pause_make: 'Suspendido',
    order_history_page_text_waiter: 'Camarero',
    order_history_page_text_customer: 'Cliente',
    order_history_page_text_extra: 'Cuota Adicional',
    order_history_page_text_order_devices: 'Otros dispositivos',
    history_order_you: 'Cliente',
    history_order_round: 'La ronda {{round}}',
    history_order_total: 'en totale: {{number}} platos',

    // $ 呼叫服务
    service_page_text_call_service_select: 'Llamar al servicio (opcional)',
    service_page_text_insert_texts: 'Ingresa el contenido (opcional)',
    service_page_text_call_waiter: 'Llamar al camarero',
    service_page_text_call_service: 'Llamar al servicio',
    service_page_text_table_name: 'Nombre de la mesa',
    service_page_text_Please_select_a_service: 'Seleccione un servicio',
    service_page_text_Your_requirement: 'Su requisito (opcional) ',
    service_page_text_call_service_success_message: 'Llamando éxito',
    service_page_input_placeholder_message: 'Introducir su necesidad...',

    // $ 购物车
    order_cart_page_text_total: 'Total',
    order_cart_page_text_complete_order: 'Has completado el pedido del turno actual.',
    order_cart_page_text_round_max_order_count: 'Límite de pedidos del turno: {{n}}',
    order_cart_page_text_round_max_number_exceed: 'Superado el límite de pedidos',
    order_cart_page_text_similar_dish_number_exceed: 'Superado el limite della categoría',
    order_cart_page_text_same_dish_number_exceed: 'Se superó el límite pedidos para este plato',
    order_cart_page_text_max_rounds_exceed: 'Superado el límite del turno',
    order_cart_page_text_dish_not_exists: 'El plato no existe',
    order_cart_page_text_commit_cart_fail: 'Error al enviar al carrito',
    order_cart_page_text_commit_success: 'Envío exitoso',
    order_cart_page_text_cart_not_data: 'Sin datos',
    order_cart_page_text_select_preferences: 'Haga clic en el nombre del plato para elegir el condimento.',
    order_cart_page_text_disable_edit_second: 'Después de {{s}} segundos, ingresamos al siguiente turno.',
    order_cart_page_text_print_credential_fail: 'Impresión fallida',
    order_cart_page_text_dish_remarks: 'Notas de los platos',
    order_cart_page_text_self: 'Self',
    order_cart_page_text_cannot_at_the_same_time: 'No envíe su carrito ni cambie ningún artículo en su carrito al mismo tiempo',
    order_cart_page_text_is_submitting: 'Enviando el pedido...',
    order_cart_page_text_round_rules: 'Solo puedes enviarlo una vez por ronda. Aún tienes una cantidad sin usar. ¿Estás seguro de que quieres enviarlo?',
    order_cart_page_text_clear: 'Limpar',
    order_cart_page_text_delete: 'Cancela',
    order_cart_page_text_exe_dishes_commit: 'Hay exceso de platos, ya sea para seguir presentando',
    order_cart_page_text_confirm_modification: 'Confirmar',
    order_cart_page_text_sync_round_info_success: 'El turno se ha actualizado con éxito',
    order_cart_page_text_dish_is_sold_out: 'Este plato no es disponible',
    order_cart_page_text_sold_out: 'Platos no disponibles',
    order_cart_Page_text_verify_sold_out_dishes_message: 'Cantidad del pedido del plato \'{{menuName}}\' es {{excessedNum}};',

    // $ 点餐
    menu_page_text_please_select_your_id: 'Por favor ingrese el ID',
    menu_page_text_check_tip_id: '¿Olvidaste tu ID? Verifique su historial de pedidos para recuperarlo',
    menu_page_text_dishes_copy: '{{n}} se ha ordenado {{1}} vez (s) en este turno',
    menu_page_text_more_than_half_ordered: '{{n}} personas pidieron {{dish}}',
    menu_page_text_not_show: 'No mostrar este mensaje de nuevo',
    menu_page_text_under_review_wait: 'En revisión, espere.',
    menu_page_text_order_success_created_jump: 'El pedido se ha creado correctamente, vaya a la página del menú',
    menu_page_text_order_does_not_exist: 'El pedido no existe o la mesa se ha reseteado, reabrirla',
    menu_page_text_review_rejected: 'Revisión rechazada',
    menu_page_text_under_review: 'En revisión',
    menu_page_text_locked_state: 'El pedido ha sido bloqueado, puede navegar por el menú libremente',
    menu_page_text_reset_send: 'Solicitar revisión',
    menu_page_text_reset_send_success: 'Solicitud exitosa',
    menu_page_text_approved: 'Aprobado',
    menu_page_text_order_unlocked: 'El pedido ha sido desbloqueado',
    menu_page_text_table_invalid: 'Mesa inválida',
    menu_page_text_customer_id_occupy: 'ID ya en uso',
    menu_page_text_dish_time_disable: 'Algunos menús han sido deshabilitados debido al cierre de la cocina.',
    menu_page_text_notice_time: 'La cocina se cerrará en {{time}} minutos. Ordene sus platos antes de que cierre la cocina.',
    menu_page_text_allergen_filter_label_message: 'Selecciona los platos a filtrar',
    menu_page_text_allergen: 'Alérgenos',
    menu_page_text_ingredents: 'Otras etiquetas de plato',
    menu_page_text_ingredent_filter_label_message: 'Selecciona los platos a filtrar',
    menu_page_text_filter: 'Filtrar',
    menu_page_text_dish_exceeded: 'El artículo que está agregando a su carrito superó el límite de cantidad para este artículo. Si continúa, es posible que se le cobre una tarifa adicional',

    // $ 扫码入口页
    home_page_text_please_select_menu: 'Selecciona el menú',
    home_page_text_number_of_adults: 'Número de adultos',
    home_page_text_number_of_child: 'Número de niños',
    home_page_text_adult_price: 'Precio niños',
    home_page_text_child_price: 'Precio niños',
    home_page_text_normal: 'Standard',
    home_page_text_special: 'Especial',
    home_page_text_table_pause_use: 'La mesa no está disponible',
    home_page_text_order_now: 'Pide ahora',
    home_page_text_get_menu_fail: 'No se pudo cargar el menú. Vuelve a intentarlo.',
    home_page_text_announcement: 'Notificación',

    // $ 公告页
    notice_page_text_no_picture: 'Sin imágen',

    // $ 过敏源种类
    text_gluten: "Gluten",
    text_crustaceans: "Crustáceos",
    text_eggs: "Huevos",
    text_fish: "Pescado",
    text_peanuts: "Maníes",
    text_soya: "Soja",
    text_milk: "Leche",
    text_tree_nuts: "Nueces",
    text_celery: "Apio",
    text_mustard: "Mostaza",
    text_sesame: "Sésamo",
    text_sulphites: "Sulfitos",
    text_lupin: "Lupino",
    text_molluscs: "Almejas",
    text_mild_spicy: "Poco picante",
    text_medium_spicy: "Medio picante",
    text_very_spicy: "Picante",
    text_frozen_origin: "Congelado",
    text_blast_freezing: "Ultracongelado",
    text_vegetarian: "Vegetariano",
    text_vegan: "Vegano",
    text_gluten_free: "Gluten free",
    text_raw: "Crudo",
    text_cooked: "Cocido",
    text_additives: "Aditivos",
    text_colourants: "Colorantes",

    // 新手引导
    novice_guide_text_select_menu: 'Selecciona el menú',
    novice_guide_text_select_normal_menu: 'Selecciona menú standard',
    novice_guide_text_select_special_menu: 'Selecciona menú especial',
    novice_guide_text_select_number_of: 'Elige el número de huéspedes',
    novice_guide_text_order: 'Pide',
    novice_guide_text_announcement: 'Notificación',
    novice_guide_text_cart: 'Carrito de compras',
    novice_guide_text_history: 'Historial de pedidos',
    novice_guide_text_call: 'Llamar al servicio',
    novice_guide_text_switch_dish_mode: 'Cambiar el modo de visualización del menú',
    novice_guide_text_first_menu: 'Selecciona el menú principal',
    novice_guide_text_switch_user: 'Mostra usuario actual',
    novice_guide_text_round_dish: 'Verifica el número de turno',
    novice_guide_text_click_dish_card_add: 'Haga clic en esta área para pedir platos',
    novice_guide_text_click_dish_card_reduce: "Haga clic en esta área para quitar los platos",
    novice_guide_text_enlarge_dish_card: "Haga clic en esta área para ver los detalles del plato",
    novice_guide_text_click_cancel: 'Haga clic para cancelar la guía',
    novice_guide_text_reduce_order: 'Reducir el pedido',
    novice_guide_text_increase_order: 'Aumentar el pedido',
    novice_guide_text_table: 'Mesa',
    novice_guide_text_enter_number: 'Ingrese el número de huéspedes',
    novice_guide_text_swipe_to_switch: 'Desliza para cambiar',
    novice_guide_text_home: 'Página principal',

    // 自助开台
    auto_open_page_text_featured_dishes: 'Platos especiales',
    auto_open_page_text_order_now: 'Pide ahora',
    auto_open_page_text_opening_hours: 'Horarios disponibles para pedir',
    auto_open_page_text_media: 'Redes Sociales',
    auto_open_page_text_website: 'Sitio web',
    auto_open_page_text_reservation: 'Reserva',
    auto_open_page_text_takeaway: 'Para llevar',
    auto_open_page_text_without_menu: 'Ningún menú es seleccionable al momento',
    auto_open_page_adults: 'Adultos',
    auto_open_page_other: 'Otros',
    auto_open_page_children: 'Niños',
    auto_open_page_text_menu: 'Menú',
    text_persons: 'Huéspedes',
    auto_open_page_open_table: 'Abrir mesa',
    auto_open_page_select: 'Seleccionar',
    auto_open_page_see_more: 'Ver más',
    auto_open_page_text_disabled_message: 'La apertura de las mesas de autoservicio está deshabilitada, por favor contacte al staff.',

    // 临时密码功能
    auto_open_page_text_set_temporary_password: 'Crea un PIN temporal',
    auto_open_page_text_input_temporary_password: 'Por favor ingrese el PIN',
    auto_open_page_text_reset_temporary_password: 'Restablecer PIN',
    auto_open_page_text_cancel_temporary_password: 'Cancelar PIN',
    auto_open_page_text_forgot_password: 'PIN olvidado',
    auto_open_page_text_input_password: 'Ingrese un número de 4 dígitos',
    auto_open_page_text_go_back: 'Volver',
    auto_open_page_text_confirm_changes: 'Confirma',
    auto_open_page_incorrect_pin: 'PIN incorrecto',
    auto_open_page_modification_failed: 'Falló la modificación',
    auto_open_page_modification_succeed: 'Modificación exitosa',
    auto_open_page_button_confirm: 'Confirma',
    auto_open_page_employee_account: 'User',
    auto_open_page_employee_password: 'Password',
    auto_open_page_pin: 'PIN',

    // 复合型营业时间
    general_text_all_day_business: 'Abierto 24 horas',
    general_text_business_hours: "horario de trabajo fijo",
    general_text_compound_business_hours: "Horas de trabajo semanales",

    // 餐厅区域
    general_text_You_are_not_in_the_restaurant_area_unable_to_order: 'No estás en la zona de restaurante, imposible pedir',
    general_text_Getting_your_location_failed: 'No se pudo obtener su ubicación correctamente',

    general_text_poor_network: 'No se puede conectar al servidor o la red es inestable. Vuelva a intentarlo más tarde',

    // 点餐 - 套餐相关
    menu_page_text_setMenu: 'Menú',
    menu_page_text_choose_the_products: 'Seleccione el producto',
    menu_page_text_add_to_cart: 'Añadir al carrito',
    menu_page_text_set_menu_required: 'requerido',
}